import { MutationTree } from "vuex";
import { IAddressLookupState } from "./types";
import {
  initialProgress,
  requestProgress,
  successProgress,
  errorProgress
} from "./";
import Vue from "vue";

export namespace ADDRESS_LOOKUP_MUTATIONS {
  export const SET_RESPONSE_BY_KEY = "setResponseByKey";
  export const SET_IS_MANUAL_BY_KEY = "setIsManualByKey";
  export const CHANGE_PROGRESS_BY_KEY = "changeProgressByKey";
}

export const mutations: MutationTree<IAddressLookupState> = {
  [ADDRESS_LOOKUP_MUTATIONS.SET_RESPONSE_BY_KEY](state, { key, data }) {
    if (!state.progress.hasOwnProperty(key)) {
      console.error(`Key '${key}' does not exist in the addressLookup module`);
      return;
    }
    Vue.set(state.responses, key, data);
  },
  [ADDRESS_LOOKUP_MUTATIONS.SET_IS_MANUAL_BY_KEY](state, { key, isManual }) {
    if (!state.progress.hasOwnProperty(key)) {
      console.error(`Key '${key}' does not exist in the addressLookup module`);
      return;
    }
    Vue.set(state.responses, key, isManual);
  },
  [ADDRESS_LOOKUP_MUTATIONS.CHANGE_PROGRESS_BY_KEY](
    state,
    { key, type, error }
  ) {
    if (!state.progress.hasOwnProperty(key)) {
      console.error(`Key '${key}' does not exist in the addressLookup module`);
      return;
    }

    switch (type) {
      case "request":
        state.progress[key] = {
          ...requestProgress
        };
        break;
      case "success":
        state.progress[key] = {
          ...successProgress
        };
        break;
      case "error":
        state.progress[key] = {
          ...errorProgress
        };

        // Set the errorMessages value if the error was a 400 response
        // from the server...
        if (
          error &&
          error.response &&
          error.response.status === 400 &&
          error.response.data
        ) {
          const exception = error.response.data.exception;
          if (exception) {
            // Check if the error message is an array or single string
            if (Array.isArray(exception)) {
              state.progress[key].errorMessages = exception.map(
                ex => ex.errorMessage
              );
            } else {
              state.progress[key].errorMessages = [exception];
            }
          }
        }
        break;
      case "initial":
        state.progress[key] = {
          ...initialProgress
        };
        break;
      default:
        break;
    }
  }
};
